import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { Events } from 'src/app/shared/constants/events.constant';
import { LoggerService } from './logger.service';

@Injectable({
  providedIn: 'root',
})
export class EventService {
  public events = new Subject<Events>();

  private hideJobPostOnInspectionManager = new Subject<boolean>();
  hideJobPostOnInspectionManager$ = this.hideJobPostOnInspectionManager.asObservable();

  constructor(private logger: LoggerService) { }

  public dispatch(event: Events) {
    this.logger.log(`Dispatching event: ${event.toString()}`);
    this.events.next(event);
  }

  setHideJobPostOnInspectionManager(value: boolean) {
    this.hideJobPostOnInspectionManager.next(value);
  }
}
